import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(loadSignupData),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(postSignupTracking),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSepaConsent),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doSignupSubmission),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doFacebookSignup),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSignupSagas);

import { defineMessages } from 'react-intl';
import { push as updatePath } from 'react-router-redux';
import { SubmissionError, change, initialize, startSubmit, stopSubmit } from 'redux-form';
import { all, call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import { loadAccountCreationConsent } from 'components/Consent/Consent.saga';
import { trackGoogleTagManagerEvent } from 'components/GoogleTagManager/GoogleTagManager';
import { selectIsPaymentMethodSepaCompatible } from 'components/PaymentMethodSelector/PaymentMethodSelector.reducer';
import { ERROR_INVALID_REQUEST, ERROR_SIGNUP_EXISTING_EMAIL, ERROR_SIGNUP_FB_EXISTING_ACCOUNT, ERROR_SIGNUP_FB_MISSING_EMAIL } from 'constants/api-error-codes';
import { authorizeFacebook, doLoginWithFacebook, getFacebookProfile } from 'features/Login/Authentication.saga';
import { userNeedsPhoneVerification } from 'features/PhoneVerification/PhoneVerification.saga';
import { getActiveProduct } from 'features/Products/Products.helpers';
import { deepExtract } from 'helpers/deep';
import { augmentSubmitActionWithAdditionalData, getFormFieldInitialValue, getFormValues } from 'helpers/forms';
import { getSelectorHtml } from 'helpers/getSelectorHtml';
import { ec, ga } from 'helpers/multitrack';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { getForApi as getUtmValues } from 'helpers/utmValues';
import { errorActionCreator, getUserLocation, gtmSafeRedirect, scrollToTop } from 'redux/saga/helpers';
import { friendbuyCode } from 'redux/saga/selectors/friendbuy';
import { selectUserLocale } from 'redux/modules/locale';
import { mixpanel } from 'components/MixPanel/MixPanel';
import { pathSelector } from 'redux/saga/selectors/request';
import { signup } from './FormAction';
export var messages = defineMessages({
  errorCreatingAccount: {
    id: 'signup.error.unableToCreateAccount',
    defaultMessage: 'Sorry, we’re unable to create your account at this time. Please, <a href="{contact}">reach out to us</a> for account help.',
    values: {
      contact: '/contact'
    }
  },
  existingAccount: {
    id: 'signup.error.existingAccount',
    defaultMessage: 'Looks like you already started creating a ClassPass account with this email address in the past. Please <a href="{loginUrl}">log in</a> to complete your purchase.'
  },
  noFacebookEmail: {
    id: 'signup.error.noFacebookEmail',
    defaultMessage: 'Your Facebook account must have an email to sign up. Please add one or sign up via email.'
  },
  typoInEmail: {
    id: 'signup.error.typoInEmail',
    defaultMessage: 'Please check your email address for misspellings.'
  }
});
export var FORM_NAME = 'signup'; // Action names

var SIGNUP_WITH_FACEBOOK = 'SIGNUP.SIGNUP_WITH_FACEBOOK';
var LOAD_SIGNUP_DATA_ERROR = 'SIGNUP.LOAD_SIGNUP_DATA_ERROR'; // Actions

export var signupWithEmail = augmentSubmitActionWithAdditionalData(signup, {
  type: 'email'
});
export var signupWithFacebook = function signupWithFacebook() {
  return {
    type: SIGNUP_WITH_FACEBOOK
  };
};
export var loadSignupError = errorActionCreator.bind(null, LOAD_SIGNUP_DATA_ERROR); // State selectors

export var getInitialValueMarketingOptOut = getFormFieldInitialValue(FORM_NAME, 'marketingOptOut');
export var getInitialValueMarketing = getFormFieldInitialValue(FORM_NAME, 'marketing');
export var getInitialValueSearchable = getFormFieldInitialValue(FORM_NAME, 'searchable');
export function loadSignupData(client) {
  var consent, ActiveProduct;
  return regeneratorRuntime.wrap(function loadSignupData$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(loadAccountCreationConsent, client);

        case 3:
          consent = _context.sent;
          _context.next = 6;
          return select(getActiveProduct);

        case 6:
          ActiveProduct = _context.sent;
          _context.next = 9;
          return all([put(initialize(FORM_NAME, consent)), put(change(FORM_NAME, 'product', ActiveProduct.key)), call(ActiveProduct.loadSignupData, client), spawn(ActiveProduct.trackSignupLoad)]);

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return put(loadSignupError(_context.t0));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}
export function postSignupTracking(signupType, profile, userId) {
  var gaEventName, locale;
  return regeneratorRuntime.wrap(function postSignupTracking$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          gaEventName = signupType === 'facebook' ? 'Sign Up by Facebook' : 'Sign Up by Email';
          _context2.next = 3;
          return select(selectUserLocale);

        case 3:
          locale = _context2.sent;
          _context2.next = 6;
          return all([call(mixpanel.alias, userId), call(ec, 'Create Account - Complete', {
            create_account_type: signupType,
            user_type: 'registered',
            email: profile.email,
            firstName: profile.first_name,
            gender: profile.gender,
            lastName: profile.last_name,
            locale: locale // TODO PV: test_branch: cohort.test_branch,

          }), call(trackOptimizelyEvent, 'create_account'), call(trackGoogleTagManagerEvent, {
            event: 'account_created',
            email_address: profile.email,
            userId: userId
          }), call(ga, 'Membership Purchase', gaEventName, userId)]);

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function loadSepaConsent() {
  var activePaymentMethodIsSepaCompatible, sepaLegalCopy;
  return regeneratorRuntime.wrap(function loadSepaConsent$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return select(selectIsPaymentMethodSepaCompatible);

        case 2:
          activePaymentMethodIsSepaCompatible = _context3.sent;

          if (activePaymentMethodIsSepaCompatible) {
            _context3.next = 5;
            break;
          }

          return _context3.abrupt("return");

        case 5:
          _context3.next = 7;
          return call(getSelectorHtml, '.sepa-terms');

        case 7:
          sepaLegalCopy = _context3.sent;
          return _context3.abrupt("return", {
            legal_copy: sepaLegalCopy,
            action: {
              form_type: 'submit'
            },
            consent_type: 'sepa_direct_debit_mandate',
            is_granted: true
          });

        case 9:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function doSignupSubmission(client, _ref) {
  var formPayload, ActiveProduct, activeLocation, sepaConsent, signupPayload, isEmailSignup, locale, initialValueMarketingOptOut, initialValueMarketing, error, initialValueSearchable, userId, profile, phoneVerificationEnabled, nextStep, path, message, _path, loginUrl, errorObj, _error;

  return regeneratorRuntime.wrap(function doSignupSubmission$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          formPayload = _ref.payload;
          _context4.next = 3;
          return select(getActiveProduct);

        case 3:
          ActiveProduct = _context4.sent;
          _context4.next = 6;
          return call(getUserLocation, client);

        case 6:
          activeLocation = _context4.sent;
          _context4.next = 9;
          return call(loadSepaConsent);

        case 9:
          sepaConsent = _context4.sent;
          _context4.t0 = _objectSpread;
          _context4.next = 13;
          return call(getUtmValues);

        case 13:
          _context4.t1 = _context4.sent;
          _context4.t2 = [{
            legal_copy: formPayload.terms,
            // Terms is a required field in CMS so will always be defined
            action: {
              form_type: 'submit'
            },
            consent_type: ['terms_of_use', 'privacy_policy'],
            is_granted: true
          }].concat(_toConsumableArray(sepaConsent ? [sepaConsent] : []));
          _context4.t3 = {
            conversion: _context4.t1,
            consents: _context4.t2
          };
          _context4.t4 = activeLocation && {
            gls_location_id: deepExtract('location.id', activeLocation)
          };
          signupPayload = (0, _context4.t0)(_context4.t3, _context4.t4);
          _context4.t5 = _objectSpread;
          _context4.t6 = {};
          _context4.t7 = signupPayload.conversion.utm;
          _context4.next = 23;
          return select(friendbuyCode);

        case 23:
          _context4.t8 = _context4.sent;
          _context4.t9 = {
            utm_term: _context4.t8
          };
          signupPayload.conversion.utm = (0, _context4.t5)(_context4.t6, _context4.t7, _context4.t9);
          _context4.prev = 26;
          isEmailSignup = formPayload.type === 'email';
          _context4.next = 30;
          return select(selectUserLocale);

        case 30:
          locale = _context4.sent;

          if (!isEmailSignup) {
            _context4.next = 48;
            break;
          }

          Object.assign(signupPayload, {
            user: {
              first_name: formPayload.firstName,
              last_name: formPayload.lastName,
              email: formPayload.email,
              password: formPayload.password,
              locale: locale
            },
            newsletter_subscribed: !!formPayload.marketing
          }); // marketingOptOutDisclaimer or marketingDisclaimer is only shown to members in some countries

          if (!formPayload.marketingOptOutDisclaimer) {
            _context4.next = 41;
            break;
          }

          _context4.next = 36;
          return select(getInitialValueMarketingOptOut);

        case 36:
          initialValueMarketingOptOut = _context4.sent;
          signupPayload.consents.push({
            legal_copy: formPayload.marketingOptOutDisclaimer,
            action: {
              form_type: 'checkbox',
              form_default: initialValueMarketingOptOut ? 'checked' : 'unchecked'
            },
            consent_type: ['marketing_emails'],
            is_granted: !formPayload.marketingOptOut // flip the logic from opt out to opt in

          });
          signupPayload.newsletter_subscribed = !formPayload.marketingOptOut; // flip the logic from opt out to opt in

          _context4.next = 46;
          break;

        case 41:
          if (!formPayload.marketingDisclaimer) {
            _context4.next = 46;
            break;
          }

          _context4.next = 44;
          return select(getInitialValueMarketing);

        case 44:
          initialValueMarketing = _context4.sent;
          signupPayload.consents.push({
            legal_copy: formPayload.marketingDisclaimer,
            action: {
              form_type: 'checkbox',
              form_default: initialValueMarketing ? 'checked' : 'unchecked'
            },
            consent_type: ['marketing_emails'],
            is_granted: signupPayload.newsletter_subscribed
          });

        case 46:
          _context4.next = 66;
          break;

        case 48:
          _context4.prev = 48;
          _context4.t10 = Object;
          _context4.t11 = signupPayload;
          _context4.next = 53;
          return call(authorizeFacebook);

        case 53:
          _context4.t12 = _context4.sent;
          _context4.t13 = {
            token: _context4.t12
          };
          _context4.t14 = {
            facebook: _context4.t13
          };

          _context4.t10.assign.call(_context4.t10, _context4.t11, _context4.t14);

          // facebookDisclaimer is only shown to members in some countries
          if (formPayload.facebookDisclaimer) {
            signupPayload.consents.push({
              legal_copy: formPayload.facebookDisclaimer,
              action: {
                form_type: 'submit'
              },
              consent_type: ['marketing_emails'],
              is_granted: true
            });
          }

          _context4.next = 66;
          break;

        case 60:
          _context4.prev = 60;
          _context4.t15 = _context4["catch"](48);
          error = new SubmissionError({
            _error: _context4.t15.message
          });
          _context4.next = 65;
          return all([spawn(ActiveProduct.trackSignupFailure), put(stopSubmit(FORM_NAME, error)), put(signup.failure(error))]);

        case 65:
          return _context4.abrupt("return");

        case 66:
          _context4.next = 68;
          return select(getInitialValueSearchable);

        case 68:
          initialValueSearchable = _context4.sent;
          signupPayload.consents.push({
            legal_copy: formPayload.searchableDisclaimer,
            action: {
              form_type: 'checkbox',
              form_default: initialValueSearchable ? 'checked' : 'unchecked'
            },
            consent_type: ['social_search'],
            is_granted: !!formPayload.searchable
          });
          _context4.next = 72;
          return call(ActiveProduct.submitSignupData, client, signupPayload);

        case 72:
          userId = _context4.sent;

          if (!isEmailSignup) {
            _context4.next = 77;
            break;
          }

          _context4.t16 = signupPayload.user;
          _context4.next = 80;
          break;

        case 77:
          _context4.next = 79;
          return call(getFacebookProfile, client && client.FB || window.FB);

        case 79:
          _context4.t16 = _context4.sent;

        case 80:
          profile = _context4.t16;
          _context4.next = 83;
          return spawn(ActiveProduct.trackSignupSuccess);

        case 83:
          _context4.next = 85;
          return call(postSignupTracking, formPayload.type, profile, userId);

        case 85:
          _context4.next = 87;
          return call(userNeedsPhoneVerification, client);

        case 87:
          phoneVerificationEnabled = _context4.sent;
          nextStep = phoneVerificationEnabled ? 'verify-phone' : 'purchase';

          if (!phoneVerificationEnabled) {
            _context4.next = 92;
            break;
          }

          _context4.next = 92;
          return put(change('verify-phone-number', 'isNewUser', true));

        case 92:
          _context4.next = 94;
          return put(signup.success());

        case 94:
          _context4.next = 96;
          return select(pathSelector);

        case 96:
          path = _context4.sent;
          _context4.next = 99;
          return put(updatePath(path.replace(/^\/signup/, "/".concat(nextStep))));

        case 99:
          _context4.next = 129;
          break;

        case 101:
          _context4.prev = 101;
          _context4.t17 = _context4["catch"](26);
          message = {
            _error: messages.errorCreatingAccount
          };

          if (!(formPayload.type === 'facebook' && _context4.t17.code === ERROR_SIGNUP_FB_EXISTING_ACCOUNT)) {
            _context4.next = 112;
            break;
          }

          _context4.next = 107;
          return call(doLoginWithFacebook, client, null, signupPayload.facebook.token);

        case 107:
          _context4.next = 109;
          return call(gtmSafeRedirect, '/');

        case 109:
          return _context4.abrupt("return");

        case 112:
          if (!(_context4.t17.code === ERROR_SIGNUP_FB_MISSING_EMAIL)) {
            _context4.next = 116;
            break;
          }

          message = {
            _error: messages.noFacebookEmail
          };
          _context4.next = 125;
          break;

        case 116:
          if (!(_context4.t17.code === ERROR_SIGNUP_EXISTING_EMAIL)) {
            _context4.next = 124;
            break;
          }

          _context4.next = 119;
          return select(pathSelector);

        case 119:
          _path = _context4.sent;
          loginUrl = "/login?returnTo=".concat(encodeURIComponent(_path));
          message = {
            _error: _objectSpread({}, messages.existingAccount, {
              values: {
                loginUrl: loginUrl
              }
            })
          };
          _context4.next = 125;
          break;

        case 124:
          if (_context4.t17.code === ERROR_INVALID_REQUEST) {
            message = {
              email: messages.typoInEmail
            };
          } else if (window.Rollbar) {
            window.Rollbar.error(_context4.t17);
          }

        case 125:
          errorObj = typeof message === 'string' ? {
            _error: message
          } : message;
          _error = new SubmissionError(errorObj);
          _context4.next = 129;
          return all([spawn(ActiveProduct.trackSignupFailure), call(scrollToTop), put(signup.failure(_error)), put(stopSubmit(FORM_NAME, errorObj))]);

        case 129:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[26, 101], [48, 60]]);
}
export function doFacebookSignup(client) {
  return regeneratorRuntime.wrap(function doFacebookSignup$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(startSubmit(FORM_NAME));

        case 2:
          _context5.t0 = call;
          _context5.t1 = doSignupSubmission;
          _context5.t2 = client;
          _context5.t3 = _objectSpread;
          _context5.t4 = {
            type: 'facebook'
          };
          _context5.next = 9;
          return select(getFormValues(FORM_NAME));

        case 9:
          _context5.t5 = _context5.sent;
          _context5.t6 = (0, _context5.t3)(_context5.t4, _context5.t5);
          _context5.t7 = {
            payload: _context5.t6
          };
          _context5.next = 14;
          return (0, _context5.t0)(_context5.t1, _context5.t2, _context5.t7);

        case 14:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function watchSignupSagas(client) {
  return regeneratorRuntime.wrap(function watchSignupSagas$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return fork(takeEvery, signup.REQUEST, doSignupSubmission, client);

        case 2:
          _context6.next = 4;
          return fork(takeEvery, SIGNUP_WITH_FACEBOOK, doFacebookSignup, client);

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}